function mostraList(target){
    var bt = document.getElementById(target);
    bt.classList.toggle('mostra');
    try {
        jQuery(`#${target}`)
            .prev("a")
            .find(".arrow-down")
            .toggleClass("arrow-down--rotate");
    } catch (error) {}
}
